import { render, staticRenderFns } from "./detailDrTboxbot.vue?vue&type=template&id=2070bc3c&scoped=true"
import script from "./detailDrTboxbot.vue?vue&type=script&lang=js"
export * from "./detailDrTboxbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070bc3c",
  null
  
)

export default component.exports